import { ButtonRoundSm } from '@apps-common/components/elements'
import { commonIcons } from '@apps-common/config/icons'
import { useProjectHook } from '@apps-common/hooks/useProjectHook'

interface IProps {
  closeModal: () => void
  overrideClasses?: string
  ignoreCtxTheme?: boolean
}

export const ModalCloseButton: React.FC<IProps> = ({ closeModal, overrideClasses, ignoreCtxTheme }) => {
  const defaultClasses = 'action-brand'
  const classes = useProjectHook(defaultClasses, 'bg-ctx-mm-brand text-ctx-on-mm-brand')

  return (
    <ButtonRoundSm type='button' className={overrideClasses || (ignoreCtxTheme ? defaultClasses : classes)} callback={() => closeModal()}>
      <commonIcons.close className='text-[1.45em]' />
    </ButtonRoundSm>
  )
}
